<div class="day-range-picker">
  <dropdown class="day-range-picker__container"
            [headerText]="'Search by'"
            [categories]="rangeStrings"
            [selectedCategory]="defaultRangeString"
            [isMobile]="false"
            (categoryChanged)="dayRangeChanged($event)">
  </dropdown>
</div>
